module.exports = __webpack_public_path__ + "img/htmlold.24e0306b.svg";